export default __webpack_public_path__ + "static/media/PutOnCupL.4ed289d3.mp4";